export const MAIN_COLOR = "#000"
export const ACCENT_COLOR = "#2b2e70"